module.exports = __webpack_public_path__ + "img/Compass.b50ff0aa.jpg";